import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-inline: var(--spacement-xxlarge);
  padding-block: var(--spacement-medium);

  @media screen and (max-width: 828px) {
    flex-direction: column;
  }
`;

export const CalendarSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;

  h3 {
    margin: 0;
    font-size: 1rem;
    color: #2a7c99;
    font-weight: 600;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 1rem;
  }
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 32px);
  gap: 4px;
`;

export const DayCell = styled.button<{ selected?: boolean; disabled?: boolean }>`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: ${({ selected }) => (selected ? '#d4f1f9' : 'transparent')};
  color: ${({ disabled }) => (disabled ? '#ccc' : '#333')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};

  &:hover {
    background: ${({ disabled }) => (disabled ? 'none' : '#f0f0f0')};
  }
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacement-medium);

  input {
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid var(--neutral-2);
    border-radius: var(--radius-small);
    color: var(--absolute-black);
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--spacement-medium);
  margin-top: -10px;
  margin-bottom: 16px;
  padding-inline: var(--spacement-xxlarge);
`
